export default {
      id: "biohazard-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#biohazard",
      toString: function () {
        return this.url;
      }
    }